import ProgressBar from 'flow/components/ui-components/ProgressBar';
import Skeleton from 'flow/components/ui-components/Skeleton';

type Props = {
    percent: number | null;
};

const QuotaProgressBar = ({ percent }: Props) => (
    <div className="mt-2 mb-4 px-2">
        {percent !== null ? (
            <ProgressBar value={percent} />
        ) : (
            <Skeleton>
                <div className="h-6 w-full rounded-sm bg-current" />
            </Skeleton>
        )}
    </div>
);

export default QuotaProgressBar;
